import { render, staticRenderFns } from "./TestCallInbound.vue?vue&type=template&id=bc4cd1b8&scoped=true&"
import script from "./TestCallInbound.vue?vue&type=script&lang=js&"
export * from "./TestCallInbound.vue?vue&type=script&lang=js&"
import style0 from "./TestCallInbound.vue?vue&type=style&index=0&id=bc4cd1b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc4cd1b8",
  null
  
)

export default component.exports